import {
	OPEN_MODAL_SOLDIER_PICK_TABLE,
	CLOSE_MODAL_SOLDIER_PICK_TABLE,
	ADD_USERS_MODAL_SOLDIER_PICK_TABLE,
} from "Store/constants";

export const initialState = {
	isOpen : false,
	data   : {},
};

const ModalSoldierPickTableProduction = (state = initialState, action) => {
	switch (action.type) {
		case OPEN_MODAL_SOLDIER_PICK_TABLE:
			return {
				...initialState,
				isOpen : true,
				...action.payload,
			};
		case ADD_USERS_MODAL_SOLDIER_PICK_TABLE:
			return {
				...state,
				userProducts : action.payload,
			};
		case CLOSE_MODAL_SOLDIER_PICK_TABLE:
			return {
				...initialState,
			};
		default:
			return state;
	}
};

export default ModalSoldierPickTableProduction;
